// ./src/azure-storage-blob.ts

// <snippet_package>
// THIS IS SAMPLE CODE ONLY - NOT MEANT FOR PRODUCTION USE
import { BlobServiceClient } from "@azure/storage-blob";

const containerName = `cp-prod-gondia`;

const sasToken = 'sv=2022-11-02&ss=bfqt&srt=sco&sp=rwlacupitfx&se=2030-12-31T16:18:01Z&st=2025-02-25T08:18:01Z&spr=https,http&sig=HZv1mUCx5HgeJ2Pq61M0H68YTBtrNs7o9JqKuRHIpGo%3D';
const storageAccountName = 'civicplanprodgondia';

export default uploadImage;

export async function uploadImage(file: File, filename: string, container: string, subcontainer: string | number) {
  if (file) {
    const blobServiceClient = new BlobServiceClient(
      `https://${storageAccountName}.blob.core.windows.net/?${sasToken}`
    );
    const containerClient = blobServiceClient.getContainerClient(containerName);
    const blobClient = containerClient.getBlobClient(`${container}/${subcontainer}/${filename}.${file.name.split('.').pop()}`);
    const blockBlobClient = blobClient.getBlockBlobClient();

    const result = await blockBlobClient.uploadBrowserData(file, {
      // blockSize: 4 * 1024 * 1024,
      concurrency: 20,
      onProgress: ev => console.log(ev),
      blobHTTPHeaders: { blobContentType: file.type }
    });
    const url = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${container}/${subcontainer}/${filename}.${file.name.split('.').pop()}`
    // Verify the URL points to our storage account
    if (!url.startsWith(`https://${storageAccountName}`)) {
      throw new Error('Invalid storage domain');
    }
    console.log(`Upload of file '${file.name}' completed`, url);
    return url
  }
  else return ''

}

export async function uploadPlotShape(file: File, filename: string, container: string) {
  if (file) {
    const blobServiceClient = new BlobServiceClient(
      `https://${storageAccountName}.blob.core.windows.net/?${sasToken}`
    );
    const containerClient = blobServiceClient.getContainerClient(containerName);
    const blobClient = containerClient.getBlobClient(`${container}/${filename}.${file.name.split('.').pop()}`);
    const blockBlobClient = blobClient.getBlockBlobClient();

    const result = await blockBlobClient.uploadBrowserData(file, {
      // blockSize: 4 * 1024 * 1024,
      concurrency: 20,
      onProgress: ev => console.log(ev),
      blobHTTPHeaders: { blobContentType: file.type }
    });
    const url = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${container}/${filename}.${file.name.split('.').pop()}`
    // Verify the URL points to our storage account
    if (!url.startsWith(`https://${storageAccountName}`)) {
      throw new Error('Invalid storage domain');
    }
    console.log(`Upload of file '${file.name}' completed`, url);
    return url
  }
  else return ''

}
